import { render, staticRenderFns } from "./Reparacion.vue?vue&type=template&id=1dc80bbc&"
import script from "./Reparacion.vue?vue&type=script&lang=js&"
export * from "./Reparacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports